.header {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  height: var(--header-height);
  z-index: 2;

  background-color: var(--brand-secondary);
}

.container {
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  max-width: var(--max-content-width);
  margin: auto;
  padding-inline: var(--content-inline-padding);
}

.al-logo {
  height: calc(var(--header-height) - 15px);
  margin-inline-end: 0.2rem;
}

.title {
  color: var(--brand-light);
  font-size: 1.5rem;
  margin: 0;
}

.user-info-container {
  padding-inline-end: 1rem;
  font-size: 0.9rem;
  font-weight: bold;
  text-align: left;
  color: var(--brand-light);
}

.logout {
  font-size: 0.7rem;
  color: var(--brand-light);
  margin: 0;
  padding: 0;

  &:hover {
    color: white;
  }
}

.account-name {
  color: var(--brand-light);
  padding-inline: 1rem;
  border-left: 1px solid var(--brand-grayscale-200);
  border-right: 1px solid var(--brand-grayscale-200);
}

.cs-logo {
  height: calc(var(--header-height) - 15px);
  padding-inline-start: 1rem;
}
